<script lang="ts" setup>
import { useMediaQuery } from '@vueuse/core'
import { merge } from 'lodash-es'

import type { UButton, UModal } from '#components'

const props = defineProps<{
  header?: string
  message?: string
  acceptLabel?: string
  rejectLabel?: string
  modalAttrs?: InstanceType<typeof UModal>['$props']
  acceptAttrs?: InstanceType<typeof UButton>['$props']
  rejectAttrs?: InstanceType<typeof UButton>['$props']
}>()

const emit = defineEmits<{
  close: [value: boolean]
}>()

const modalProps = computed(() => {
  const ui = {
    content: 'max-w-sm',
    footer: 'justify-between flex-wrap',
    body: 'wrap-anywhere',
  }
  return merge({ title: props.header || 'Подтверждение', ui }, props.modalAttrs)
})
const isMobile = useMediaQuery('(max-width: 640px)')

const accept = () => {
  emit('close', true)
}

const reject = () => {
  emit('close', false)
}
</script>

<template>
  <UModal v-bind="modalProps">
    <template #body>
      {{ props.message || 'Вы уверены?' }}
    </template>
    <template #footer>
      <UButton
        color="neutral"
        variant="ghost"
        :label="props.rejectLabel || 'Отмена'"
        v-bind="props.rejectAttrs"
        :size="isMobile ? 'md' : 'xl'"
        @click="reject"
      />
      <UButton
        color="error"
        :label="props.acceptLabel || 'Подтвердить'"
        v-bind="props.acceptAttrs"
        :size="isMobile ? 'md' : 'xl'"
        @click="accept"
      />
    </template>
  </UModal>
</template>
